import dayjs from 'dayjs';

const YEAR = dayjs().year();

export function Footer() {
  return (
    <footer className="hidden items-center justify-between border-t border-border px-6 py-3 text-xs text-muted-foreground sm:flex">
      <span>© {YEAR} Moveris, Inc. All rights reserved.</span>
      <div className="flex gap-4">
        <a
          href="https://www.moveris.com/legal/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          Terms &amp; Conditions
        </a>
        <a
          href="https://www.moveris.com/legal/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          Privacy Policy
        </a>
      </div>
    </footer>
  );
}
